module.exports = __webpack_public_path__ + "img/solution-market2.58f27497.png";